import React from 'react';
import Navbar from '../../components/navbar';
import FormularioNuevaSucursal from '../../components2/formularioNuevaSucursal';

function NuevaSucursal () {
    return (
        <FormularioNuevaSucursal />
    )
}

export default NuevaSucursal;